import { Injectable } from '@angular/core';
import { BehaviorSubject, of, map } from 'rxjs';
import { FilterType } from '../models/filter-type';
import { environment } from 'src/environments/environment';
import { AuthService } from './auth.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { SponsoredCarouselModel } from '../models/data.model';
// import { defer, Observable, of, Subject, throwError } from 'rxjs';
// import { map } from 'rxjs/operators';



@Injectable({
  providedIn: 'root'
})
export class CommonService {

  public windowObj: any = window;

  public _postSelectedFilters = new BehaviorSubject<FilterType[]>([]);
  public _selectedFiltersRefresh = this._postSelectedFilters.asObservable();

  public sponsoredCarouselInitialised: boolean = false;


  constructor(
    private _http: HttpClient,
    private authService: AuthService,
  ) { }

  /** 
    Initialize the count of each category in the offers.
  */
  public initCount(offers: any) {
    let filtersCountMap: any = {}
    if (offers) {
      offers.forEach((offer: any) => {
        if (filtersCountMap[offer.categoryId]) {
          filtersCountMap[offer.categoryId]++;
        } else {
          filtersCountMap[offer.categoryId] = 1;
        }
      });
    }
    return filtersCountMap
  }

  public fetchGuestFAQ() {
    const displayableBannerName: string = this.windowObj['AB']['userInfo']['displayableBanner'];
    const formattedBannerName = displayableBannerName.toLowerCase().replace(/[\s'.-]+/g, '');
    let url = this.authService.getApplicationDomainURL() + environment.FORU_GUEST_BANNER.replace('{banner}', formattedBannerName).replace('{banner}-forU', formattedBannerName + '-forU');
    const headers = new HttpHeaders().set('X-Service-Name', 'CommonService').set('X-Function-Name', 'fetchGuestFAQ');
    return this._http.get(url, { headers, responseType: 'text' }).pipe(
      map((data: any) => {
        if (data) {
          data = data.replace(/\(displayableBanner\)/g, this.windowObj['AB'].userInfo.displayableBanner);
          data = data.replace(/\(banner\)/g, this.windowObj['AB'].userInfo.banner);
          data = data.replace(/\(banner4U\)/g, this.windowObj['AB'].userInfo.displayableBanner);
          data = data.replace(/\(bannerName\)/g, this.windowObj['AB'].userInfo.displayableBanner);
          return data;
        }
      }
      ));
  }

  public ariaFocusHandler(elem : HTMLElement, ariaLabelMsg: string) {
    if(elem) {
      elem.setAttribute('aria-label', ariaLabelMsg);
      elem.setAttribute('tabIndex', '-1');
      elem.focus();
    }
  }


  public trapFocus(modalId: any) {
 
    let modal = document.querySelector(modalId); // select the modal by it's id

    let focusableElements = modal.querySelectorAll("a[href]:not([tabindex='-1']):not(.inactive),area[href]:not([tabindex='-1']),input:not([disabled]):not([tabindex='-1']),select:not([disabled]):not([tabindex='-1']),textarea:not([disabled]):not([tabindex='-1']),button:not([disabled]):not([tabindex='-1']),iframe:not([tabindex='-1']),[tabindex]:not([tabindex='-1'])");
    let firstFocusableElement = focusableElements[0];
    let lastFocusableElement = focusableElements[focusableElements.length - 1];

    if (modal) {
        firstFocusableElement.focus();
        modal.addEventListener('keydown', function (e: any) {
            let isTabPressed = e.key === 'Tab' || e.keyCode === 9;

            if (!isTabPressed) {
                return;
            }

            if (e.shiftKey) {
                if (document.activeElement === firstFocusableElement) {
                    lastFocusableElement.focus();
                    e.preventDefault();
                }
            } else {
                if (document.activeElement === lastFocusableElement) {
                    firstFocusableElement.focus();
                    e.preventDefault();
                }
            }
        });
    }
  }

  public fetchGetBannerUnitXF() {
    const displayableBannerName: string = this.windowObj['AB']['userInfo']['displayableBanner'];
    const formattedBannerName = displayableBannerName.toLowerCase().replace(/[\s'.-]+/g, '');
    const url = this.authService.getApplicationDomainURL() + environment.FORU_GUEST_BANNER_UNIT_XF.replace('{banner}', formattedBannerName).replace('{banner}-forU', formattedBannerName + '-forU');
    const headers = new HttpHeaders().set('X-Service-Name', 'CommonService').set('X-Function-Name', 'fetchGetBannerUnitXF');
    return this._http.get(url, { headers, responseType: 'text' });
  }

  public getAbCart(): any{
    const abCart = localStorage.getItem('abCart');
    if(abCart){
      return JSON.parse(abCart);
    }
    return {};
  }

  private constructFilterQueries(filters: FilterType[]){
    let filtersDestructured:any = {};
    if(filters.length === 0){
      return '';
    }
    filters.forEach((filter)=>{
      if(filtersDestructured[filter.filterProperty]){
        filtersDestructured[filter.filterProperty] = `${filtersDestructured[filter.filterProperty]}OR"${filter.filterName}"`;
      }else{
        filtersDestructured[filter.filterProperty] = `"${filter.filterName}"`;
      }
    })
    let filterQueryArray = []
    for (var key in filtersDestructured){
      filterQueryArray.push(`fq=${key}:${encodeURIComponent(filtersDestructured[key])}`);
    }
    return `&${filterQueryArray.join('&')}`;
  }

  public trackFilterUpdates(shouldTrack: Boolean, action?: String, filterType?: String, filterSelection?: String, shouldRemoveFilterType?: Boolean) {
    if (this.windowObj['AB'] && this.windowObj['AB']['DATALAYER']) {
      if (action === 'add') {
        this.windowObj['AB']['DATALAYER'].addFilterType(filterType?.toLowerCase());
        this.windowObj['AB']['DATALAYER'].addFilterSelection(`${filterType?.toLowerCase()?.trim()}: ${filterSelection?.trim()}`);
      } else if (action === 'remove') {
        if (shouldRemoveFilterType) {
          this.windowObj['AB']['DATALAYER'].removeFilterType(filterType?.toLowerCase());
        }
        this.windowObj['AB']['DATALAYER'].removeFilterSelection(filterSelection === 'clearAll' ? 'clearAll' : `${filterType?.toLowerCase()?.trim()}: ${filterSelection?.trim()}`);
      }
      if (shouldTrack) {
        this.windowObj['AB']['DATALAYER'].setPageFilter();
      }
    }
  }

  public setLeftNavActiveLink() {
    const navElement = document.querySelector('.left-navigation-level__categories-tree');
    if (navElement) {
      const anchorElements = navElement.querySelectorAll('a');
      for (const anchor of Array.from(anchorElements)) {
        if ((anchor as HTMLAnchorElement).href === window.location.href) {
          (anchor as HTMLAnchorElement).classList.add('active');
          break;
        }
      }
    }
  }

}
